import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

export default function ButtonCollapse({
  target, controls, className, expanded,
}) {
  return (
    <div className="btn-collapse">
      <Button
        variant="link"
        className={`${expanded ? '' : 'collapsed'} ${className}`}
        data-bs-toggle="collapse"
        data-bs-target={target}
        aria-controls={controls}
        aria-expanded={expanded}
      />
    </div>
  );
}

ButtonCollapse.propTypes = {
  target: PropTypes.string.isRequired,
  controls: PropTypes.string.isRequired,
  className: PropTypes.string,
  expanded: PropTypes.bool,
};

ButtonCollapse.defaultProps = {
  className: '',
  expanded: false,
};
